document.addEventListener('DOMContentLoaded', function () {
  var ITEM = '.ai-product-preferences-item-az2hdukrsestkvlhxzaigenblock9ff84774t9jeh';
  var IMAGE_WRAP = '.ai-product-preferences-image-wrapper-az2hdukrsestkvlhxzaigenblock9ff84774t9jeh';
  var BADGE = '.EasyStock-Badge';

  function moveBadges() {
    document.querySelectorAll(ITEM).forEach(function (item) {
      var badge = item.querySelector(BADGE);
      var imageWrap = item.querySelector(IMAGE_WRAP);

      if (!badge || !imageWrap) return;

      if (badge.parentElement !== imageWrap) {
        imageWrap.appendChild(badge);
      }
    });
  }

  moveBadges();

  var root = document.querySelector('.ai-product-preferences-container-az2hdukrsestkvlhxzaigenblock9ff84774t9jeh');
  if (root) {
    var obs = new MutationObserver(function () {
      moveBadges();
    });

    obs.observe(root, {
      childList: true,
      subtree: true
    });
  }
});